import { styled } from "theme/default/styled";
import { setFlexDF } from "theme/setter/setFlexValues/setFlexDF";

export const SUnSelectedActionStepButtons = styled.div`
  margin-top: auto;

  ${setFlexDF};
`;
